import { SelfServeContext } from "../../types";

import { isActiveInsider } from "./shared-utils";

export const ManageInsiderMembershipVisibilityFn = (
  _context: SelfServeContext
) => Promise.resolve(isActiveInsider());
